import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InscriptionDetailComponent } from './inscription-detail/inscription-detail.component';
import { InscriptionItemComponent } from './inscription-item/inscription-item.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipeModule } from 'src/app/pipes/pipe-module.module';
import { TranslateModule } from '@ngx-translate/core';
import { GeneralesComponentsModule } from 'src/app/generales-components/generales-components.module';

const declarations = [
  InscriptionDetailComponent,
  InscriptionItemComponent
]

@NgModule({
  declarations: declarations,
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    PipeModule,
    TranslateModule,
    GeneralesComponentsModule
  ],
  exports: declarations
})
export class ComponentsInscriptionModule { }
